import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ProfileForm from '../components/profile/ProfileForm';
import ChangePasswordForm from '../components/profile/ChangePasswordForm';
import EmailVerificationSection from '../components/profile/EmailVerificationSection';
import './ProfilePage.css';

const ProfilePage = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-tabs">
          <button
            className={`tab-button ${activeTab === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            Details
          </button>
          <button
            className={`tab-button ${activeTab === 'password' ? 'active' : ''}`}
            onClick={() => setActiveTab('password')}
          >
            Change password
          </button>
        </div>

        <div className="profile-content">
          {activeTab === 'profile' && (
            <>
              <EmailVerificationSection />
              <ProfileForm />
            </>
          )}
          {activeTab === 'password' && <ChangePasswordForm />}
        </div>

        <div className="profile-info">
          <div className="user-card">
            <div className="user-avatar">
              <span className="avatar-text">
                {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || 'U'}
              </span>
            </div>
            <div className="user-details">
              <h3>{user?.name}</h3>
              <p>{user?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
